import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const WorkCard = (certificates) => {
  const { title, platform, skills, date, image, credential } = certificates;
  return (
    <Box
      sx={{
        backgroundColor: "#7a3f41", //000F2E
        padding: 3,
        border: "1px solid #B3565B",
        borderRadius: "10px",
        width: "80%",
        "@media (min-width: 1000px)": {
          maxWidth: "1000px",
        },
        position: "relative",
        display: "flex",
        mx: 3,
      }}
    >
      <Box
        component="img"
        sx={{ maxHeight: "45px", maxWidth: "45px", objectFit: "cover" }}
        src={image}
      />
      <a href={credential} target="_blank" rel="noopener">
        <Box
          sx={{
            maxWidth: "1000px",
            mx: 2,
          }}
        >
          <Typography sx={{ color: "white", mb: 0 }}>{title}</Typography>

          <Typography variant="body1" sx={{ color: "white", mb: 0 }}>
            {platform}
          </Typography>
          <Typography variant="body2">
            <span style={{ color: "#35191a", fontWeight: "bold" }}>
              {date}{" "}
            </span>
            <span style={{ color: "#b8babc" }}> {skills}</span>
          </Typography>
        </Box>
      </a>
    </Box>
  );
};

export default WorkCard;
